import React from 'react';
import SpecList from './SpecList';
import './ModelSpecListPanel.css';

/**
 * 모델별 사양 리스트 전용 영역 — 메인 리스트와 별도의 패널·카드형 목록(SpecList deck 모드)으로 표시
 */
const ModelSpecListPanel = (props) => (
    <section className="model-spec-list-panel" aria-labelledby="model-spec-list-panel-title">
        <header className="model-spec-list-panel__intro">
            <h2 id="model-spec-list-panel-title" className="model-spec-list-panel__title">
                모델별 사양 리스트
            </h2>
            <p className="model-spec-list-panel__desc">
                메인 리스트와 데이터를 따로 불러옵니다. 검색·필터는 이 목록에만 적용되며, 모델명 중심 카드에서 펼쳐 사양을 확인·편집할 수 있습니다.
            </p>
        </header>
        <div className="model-spec-list-panel__body">
            <SpecList
                {...props}
                listVariant="modelSpecList"
                listSummaryModelNameOnly
                presentationVariant="modelSpecDeck"
                omitSectionHeading
            />
        </div>
    </section>
);

export default ModelSpecListPanel;
